<template>
  <base-section
    id="info-alt"
    space="56"
  >
    <v-container>
      <v-row justify="space-between">
        <v-col
          cols="12"
          md="6"
        >
          <base-contact-form title="MAIL US YOUR MESSAGE" />
        </v-col>

        <v-col
          cols="12"
          md="6"
        >
           <base-address-form title="CONTACT" />
          <iframe
            allowfullscreen
            aria-hidden="false"
            frameborder="0"
            height="200"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d31908.431861309753!2d103.782652!3d1.442461!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da1306c201167f%3A0x1300f7ac70dda9b2!2sSingapore%20739085!5e0!3m2!1sen!2ssg!4v1607578857357!5m2!1sen!2ssg"
            style="border:0; display: block;"
            tabindex="0"
            width="100%"
          />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionMap',
    provide: {
      heading: { align: 'center' },
    },
  }
</script>
